import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, ArrowRight, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_TERRACOTTA = "https://customer-assets.emergentagent.com/job_academy-session/artifacts/gtms0r7v_Logo%20Agence%20Immobilier%20Minimaliste%20Marron%20Gris%20Beige%20-%203.PNG";

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      if (res.data.success) {
        localStorage.setItem('admin_token', res.data.token);
        localStorage.setItem('admin_email', res.data.admin.email);
        localStorage.setItem('admin_name', res.data.admin.name);
        toast.success('Connexion réussie');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Email ou mot de passe incorrect');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-8">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img 
            src={LOGO_TERRACOTTA} 
            alt="L'Académie" 
            className="h-12 mx-auto mb-6"
            data-testid="admin-login-logo"
          />
          <h1 className="font-display text-3xl font-light text-brown mb-2">
            Espace <em className="italic text-terra">Admin</em>
          </h1>
          <p className="font-body text-sm text-brown-mid">
            Connectez-vous pour gérer les réservations et les formations
          </p>
        </div>

        <form onSubmit={handleLogin} className="bg-white border border-sand p-8" data-testid="admin-login-form">
          <div className="mb-5">
            <label className="form-label block mb-2">EMAIL</label>
            <div className="relative">
              <input
                type="email"
                className="form-input w-full pr-10"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                autoFocus
                data-testid="admin-email-input"
              />
              <Mail size={16} className="absolute right-4 top-1/2 -translate-y-1/2 text-brown-light" />
            </div>
          </div>

          <div className="mb-6">
            <label className="form-label block mb-2">MOT DE PASSE</label>
            <div className="relative">
              <input
                type="password"
                className="form-input w-full pr-10"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
              <Lock size={16} className="absolute right-4 top-1/2 -translate-y-1/2 text-brown-light" />
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="cta-button w-full flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="admin-login-button"
          >
            {isLoading ? 'Connexion...' : 'Se connecter'}
            <ArrowRight size={16} />
          </button>
        </form>

        <p className="text-center text-xs text-brown-light mt-6">
          <a href="/" className="link-underline">← Retour au site</a>
        </p>
      </div>
    </div>
  );
}
